'use strict';

var m = angular.module('ui.utils.masks.us', [])
	.directive('uiUsPhoneNumberMask', require('./phone/us-phone'));

module.exports = m.name;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-input-masks/src/us/us-masks.js
 ** module id = 332
 ** module chunks = 1
 **/